
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"
import { BModal, BIconFileEasel } from "bootstrap-vue"

type Hyperlink = {
	text: string,
	url: string,
	replaceExistingText: boolean
}

@Component({
	components: {
		"hyperlinkModal": BModal
	}
})

export default class HyperlinkModal extends Vue {
	@Prop(String)
	text!: string

	private hyperlinkText: string = ""
	private hyperlinkUrl: string = ""
	private replaceText: boolean = false
	private isDisabled: boolean = true

	private get isValid () : boolean {
		// checks that there is a URL and text for the hyperlink
		return !(this.hyperlinkUrl.trim().length > 0 && (this.hyperlinkText.trim().length > 0 || this.text.trim().length > 0))
	}

	@Emit("onSubmit")
	handleOkClicked (submitEvent: any) {
		// flag that the text the hyperlink is based on will need to be replaced
		if (this.text.length > 0) {
			this.hyperlinkText = this.text
			this.replaceText = true
		}

		// prefix the URL if no protocol is found in the URL
		if (!this.hyperlinkUrl.toLowerCase().includes("://")) {
			this.hyperlinkUrl = "http://" + this.hyperlinkUrl
		}

		const hyperlinkObj: Hyperlink = {
			text: this.hyperlinkText,
			url: this.hyperlinkUrl,
			replaceExistingText: this.replaceText
		}

		return hyperlinkObj
	}

	@Emit("onCancel")
	handleCancelClicked (submitEvent: any) {

	}
}
